import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Cultura } from 'src/app/classes/Cultura';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { ListaComponent } from './lista/lista.component';
import { TabLateralComponent } from './tab-lateral/tab-lateral.component';

@Component({
  selector: 'app-plano-mestre-producao',
  templateUrl: './plano-mestre-producao.component.html',
  styleUrls: ['./plano-mestre-producao.component.scss']
})
export class PlanoMestreProducaoComponent implements OnInit {

  @ViewChild("listaPlanejamento", { static: false }) listaPlanejamento: ListaComponent;
  @ViewChild("tablateral", { static: false }) tablateral: TabLateralComponent;
  culturas: Cultura[];
  culturaSelecionada: Cultura;

  carregando: boolean = false;

  constructor(private planejamentoService: PlanejamentoService) {
    this.carregando = true;
    this.planejamentoService.getCulturas().subscribe(ret =>{
      this.culturas = ret;
      this.carregando = false;
    });
  }

  ngOnInit() {
  }

  changeCarregandoLista(value: boolean): void {
    if(this.tablateral)
     this.tablateral.carregando = value
  }

  changeCultura(event): void {

    this.culturaSelecionada = event;
    if(this.listaPlanejamento && event)
      this.listaPlanejamento.listarPlanejamentos(event.Id)
  }
}
